<div class="pending-inventory-section">
  <div class="pending-header-row">
    <mat-icon color="warn">warning</mat-icon>
    <h3>Pending Inventory &mdash; Lot Number Not Yet Assigned</h3>
    <span *ngIf="!loading" class="pending-badge">
      {{ dataSource.data.length }}
    </span>
  </div>

  <div *ngIf="loading" class="loading-message">
    <p>Loading pending inventory...</p>
  </div>

  <div *ngIf="error" class="error-message">
    <p>{{ error }}</p>
  </div>

  <ng-container *ngIf="!loading && !error">
    <div *ngIf="dataSource.data.length === 0" class="no-pending">
      <mat-icon class="no-pending-icon">check_circle</mat-icon>
      <p>All purchased inventory has been assigned lot numbers.</p>
    </div>

    <ng-container *ngIf="dataSource.data.length > 0">
      <mat-form-field class="filter-field">
        <mat-label>Search pending inventory</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search by PO #, vendor, product..." #input>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <table mat-table [dataSource]="dataSource" class="pending-inventory-table">

        <ng-container matColumnDef="purchaseOrderNumber">
          <th mat-header-cell *matHeaderCellDef>PO #</th>
          <td mat-cell *matCellDef="let item">{{ item.purchaseOrderNumber || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="orderDate">
          <th mat-header-cell *matHeaderCellDef>Order Date</th>
          <td mat-cell *matCellDef="let item">{{ item.orderDate ? (item.orderDate | date:'MM/dd/yyyy') : '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="vendorName">
          <th mat-header-cell *matHeaderCellDef>Vendor</th>
          <td mat-cell *matCellDef="let item">{{ item.vendorName || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="productName">
          <th mat-header-cell *matHeaderCellDef>Product</th>
          <td mat-cell *matCellDef="let item">{{ item.productName || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="catalogNum">
          <th mat-header-cell *matHeaderCellDef>Catalog #</th>
          <td mat-cell *matCellDef="let item">{{ item.catalogNum || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="vendorCatalogNum">
          <th mat-header-cell *matHeaderCellDef>Vendor Catalog #</th>
          <td mat-cell *matCellDef="let item">{{ item.vendorCatalogNum || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef>Qty</th>
          <td mat-cell *matCellDef="let item">{{ item.quantity }}</td>
        </ng-container>

        <ng-container matColumnDef="unitType">
          <th mat-header-cell *matHeaderCellDef>Unit</th>
          <td mat-cell *matCellDef="let item">{{ item.unitType || '—' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"
            class="table-row clickable-row"
            (click)="viewPurchaseOrder(row)"
            matTooltip="Open Purchase Order to assign lot numbers"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-filter-results" [attr.colspan]="columns.length">
            No pending inventory matches "{{ input.value }}"
          </td>
        </tr>
      </table>

      <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons></mat-paginator>
    </ng-container>
  </ng-container>
</div>
